import React from 'react';
import { Outlet } from 'react-router-dom';
import AccessDeniedCard from '../../../components/AccessDeniedCard';
import { usePermissions } from '../../../hooks/usePermissions';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import { READ_BULK_UPLOAD, READ_SALE_CREDIT_NOTE, READ_SALE_INVOICE, READ_PURCHASE_INVOICE, READ_PURCHASE_CREDIT_NOTE } from '../../../constants/eInvoicePermissions';
import { BULK_UPLOAD_MODULE_KEY } from '../../settings/constants/roleModules';

export default function BulkUploadAccessLayout() {
  const { loading, hasEInvoicePermission } = usePermissions();
  const title = useRoleModuleLabel(BULK_UPLOAD_MODULE_KEY);

  if (loading) {
    return null;
  }

  const canReadResource = (hasEInvoicePermission(READ_SALE_INVOICE) || hasEInvoicePermission(READ_SALE_CREDIT_NOTE)) || (hasEInvoicePermission(READ_PURCHASE_INVOICE) || hasEInvoicePermission(READ_PURCHASE_CREDIT_NOTE));
  const isAllowed = hasEInvoicePermission(READ_BULK_UPLOAD) && canReadResource;

  if (!isAllowed) {
    return <AccessDeniedCard title={title} />;
  }

  return <Outlet />;
}
